import LocalizedStrings from 'react-localization';
import english from './english';
import hindi from './hindi';

const strings = new LocalizedStrings({
  english,
  hindi,
});

export default strings;
